import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AlignRight from './icon-align-right.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AlignRight {...validProps} />;
}
SvgComponent.iconName = 'alignRight';

/**
 * @deprecated This is a legacy icon
 */
export const AlignRightIcon = svgIconWrapper(SvgComponent);
